import { email, required, useGetIdentity, useRecordContext } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { TextInput } from "@/components/admin/text-input";
import { SelectInput } from "@/components/admin/select-input";

import type { Sale } from "../types";

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  return (
    <div className="space-y-4 w-full">
      <TextInput
        source="first_name"
        label="Nome"
        validate={required()}
        helperText={false}
      />
      <TextInput
        source="last_name"
        label="Sobrenome"
        validate={required()}
        helperText={false}
      />
      <TextInput
        source="email"
        label="E-mail"
        validate={[required(), email()]}
        helperText={false}
      />
      <SelectInput
        source="deal_permission"
        label="Conjunto de permissão — Deals"
        choices={[
          { id: "user", name: "Usuário comum de negócios" },
          { id: "admin", name: "Administrador dos negócios" },
        ]}
        defaultValue="user"
        helperText={false}
      />
      <SelectInput
        source="global_permission"
        label="Conjunto de permissão — Global"
        choices={[
          { id: "user", name: "Usuário comum global" },
          { id: "admin", name: "Administrador global" },
        ]}
        defaultValue="user"
        helperText={false}
      />
      <SelectInput
        source="status"
        label="Status da conta"
        choices={[
          { id: "active", name: "Ativo" },
          { id: "invited", name: "Convidado" },
          { id: "disabled", name: "Desativado" },
        ]}
        defaultValue="active"
        helperText={false}
      />
      <BooleanInput
        source="administrator"
        label="Administrador geral do sistema"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
      <BooleanInput
        source="disabled"
        label="Desativar acesso"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
    </div>
  );
}
